import React from 'react';
import './PoliticaDePrivacidad.css';

const PoliticaDePrivacidad = () => {
  return (
    <div className="politica-de-privacidad">
      <h1>Política de Privacidad</h1>

      <section>
        <h2>Datos Legales</h2>
        <p>
          En cumplimiento de la Ley 34/2002, con última actualización, 09/05/2023, de servicios de la sociedad de la
          información y de comercio electrónico, AL-ANDALUS FEELING SLU, le informa que es titular de los sitios web:
          <a href="https://www.sageservice.es/" target="_blank" rel="noopener noreferrer"> https://www.sageservice.es/</a>.
          De acuerdo con la exigencia del artículo 10 de la mencionada Ley, notifica los siguientes datos:
        </p>
        <ul>
          <li><strong>NIF/CIF:</strong> B02657674</li>
          <li><strong>Registro Mercantil:</strong> Granada, Tomo: 1739, Folio: 185, S8, Hoja: GR-55371</li>
          <li><strong>Domicilio social:</strong> C/ Aristóteles, 36, 18100, Armilla (Granada)</li>
          <li><strong>Correo electrónico:</strong> <a href="mailto:info@sageservices.es">info@sageservices.es</a></li>
        </ul>
      </section>

      <section>
        <h2>Usuario y Régimen de Responsabilidades</h2>
        <p>
          La navegación por acceso o uso de la página web, así como todos los subdominios y directorios incluidos bajo
          el mismo dominio, otorga la condición de Usuario, por la que se aceptan todas las condiciones de uso que se
          establecen sin perjudicar la aplicación de la correspondiente normativa legal. Si no está de acuerdo, le
          rogamos que no utilice el portal.
        </p>
        <p>
          El usuario asume la responsabilidad de usar correctamente la página web, incluyendo proporcionar información
          veraz en formularios, respetar la ley, la moral y el orden público.
        </p>
      </section>

      <section>
        <h2>Acceso a Reseñas de Usuarios</h2>
        <p>
          Según el Real Decreto Legislativo-24/2021 y el artículo 20.4 de la Ley General para la Defensa de los
          Consumidores y Usuarios, las prácticas comerciales que faciliten acceso a reseñas deben garantizar que estas
          han sido realizadas por usuarios reales.
        </p>
        <p>
          Los usuarios tienen acceso a escribir reseñas sobre la actividad de esta web mediante un formulario específico
          y con la aceptación de esta Política de Privacidad.
        </p>
      </section>

      <section>
        <h2>Política de Enlaces y Exenciones de Responsabilidad</h2>
        <p>
          AL-ANDALUS FEELING SLU no se hace responsable del contenido de las páginas web externas a las que se acceda
          mediante enlaces desde sus sitios web. Tampoco garantiza la disponibilidad técnica ni la exactitud del
          contenido de estas páginas externas.
        </p>
        <p>
          AL-ANDALUS FEELING SLU no se responsabiliza de los daños producidos en los equipos informáticos de los
          usuarios durante la navegación.
        </p>
      </section>

      <section>
        <h2>Publicidad</h2>
        <p>
          La web podrá alojar contenidos publicitarios cuyos responsables son los anunciantes. AL-ANDALUS FEELING SLU no
          será responsable de errores o irregularidades en dichos contenidos.
        </p>
      </section>

      <section>
        <h2>Modificaciones</h2>
        <p>
          AL-ANDALUS FEELING SLU se reserva el derecho a realizar modificaciones en el contenido de su sitio web sin
          previo aviso. Dichas modificaciones serán de obligado cumplimiento mientras estén publicadas.
        </p>
      </section>

      <section>
        <h2>Propiedad Intelectual</h2>
        <p>
          Los derechos de propiedad intelectual de todos los textos, imágenes y formas de presentación de esta web
          pertenecen a AL-ANDALUS FEELING SLU y están protegidos por la normativa vigente.
        </p>
      </section>

      <section>
        <h2>Acciones Legales y Jurisdicción</h2>
        <p>
          La relación entre los usuarios y AL-ANDALUS FEELING SLU se regirá por la normativa española vigente, siendo
          competentes los juzgados de Granada.
        </p>
      </section>

      <section>
        <h2>Política de Cookies</h2>
        <p>
          AL-ANDALUS FEELING SLU utiliza cookies para almacenar información y mejorar la experiencia del usuario. Puede
          configurar su navegador para aceptar o rechazar cookies según desee.
        </p>
      </section>

      <section>
        <h2>Política de Privacidad</h2>
        <p>
          Conforme al RGPD-UE-2016/679 y otras normativas, AL-ANDALUS FEELING SLU garantiza el secreto profesional sobre
          los datos personales recogidos mediante formularios en esta web.
        </p>
        <p>
          Los usuarios pueden ejercer sus derechos de acceso, rectificación, oposición, supresión, limitación y
          portabilidad de sus datos mediante comunicación a <a href="mailto:info@sageservices.com">info@sageservices.com</a>, adjuntando una
          fotocopia del DNI.
        </p>
      </section>

      <footer>
        <p>Actualizada: 08/11/2023</p>
      </footer>
    </div>
  );
};

export default PoliticaDePrivacidad;
